import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { LocationsService, District, RequireMatch } from '../../../core';
import { Observable } from 'rxjs';
import { debounceTime, startWith, switchMap, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-district-autocomplete',
  templateUrl: './district-autocomplete.component.html',
  styleUrls: ['./district-autocomplete.component.scss']
})
export class DistrictAutocompleteComponent implements OnInit {
  filteredDistrict: Observable<District[]>;
  district: FormControl = new FormControl;
  @Output() selectedDistrict = new EventEmitter<any>();
  constructor(private locationsService:LocationsService) {
    this.district.setValidators(RequireMatch);
   }

  ngOnInit() {
  }

  listDistricts() {
    if (this.filteredDistrict) return;
    this.filteredDistrict = this.district.valueChanges
    .pipe(
      debounceTime(600),
      startWith(''),
      switchMap(change =>
        typeof change === 'string'
          ? this.locationsService._filterDistrict(change, false)
          : [[]]
      ),
      map(name => {
        return name;
      })
    );
  }

  displayFn(district?: any): string | undefined {
    return district
      ? `${district.district} - ${district.province} - ${district.department}`
      : undefined;
  }


  emitEvent(){
    this.selectedDistrict.emit(this.district.value);
  }

  clearForm(){
    this.district.reset();
  }

  resetForm(){
    this.clearForm();
    this.emitEvent();
  }
}
